// extracted by mini-css-extract-plugin
module.exports = {"input_contain":"Input_input_contain__QUxsR","input_valido":"Input_input_valido__h3gd3","label":"Input_label__6peix"};